import { ModalidadSeleccion } from '../models/modalidad-seleccion.interface';

export interface ModalidadSeleccionState {
  modalidadesSeleccion: ModalidadSeleccion[];
  selectedModalidadSeleccion: ModalidadSeleccion | null;
  loading: boolean;
  error: string | null;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  searchResults: ModalidadSeleccion[];
  searchQuery: string;
}

export const initialModalidadSeleccionState: ModalidadSeleccionState = {
  modalidadesSeleccion: [],
  selectedModalidadSeleccion: null,
  loading: false,
  error: null,
  creating: false,
  updating: false,
  deleting: false,
  searchResults: [],
  searchQuery: ''
};
